<template>
	<div class="editMoonSampleInfoClass">
		<el-page-header @back="goBack" class="backClass" content="编辑页面"> </el-page-header>
		<div class="titleNameClass">{{ sampleEditData.code }}</div>

		<div class="contentDivClass">
			<div class="spanInforDivClass">
				<div class="titleDivClass">
					<span class="lineClass"></span>
					<span class="titleSpanNameClass">探测任务信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">探测任务</span>
						<el-input v-model="sampleEditData.task"></el-input>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">地点</span>
						<el-input v-model="sampleEditData.place"></el-input>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">经度</span>
						<el-input v-model="sampleEditData.longitude"></el-input>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">纬度</span>
						<el-input v-model="sampleEditData.latitude"></el-input>
					</div>
				</div>

				<div class="titleDivClass">
					<span class="lineClass"></span>
					<span class="titleSpanNameClass">样品基本信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">样品编号</span>
						<el-input v-model="sampleEditData.code"></el-input>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">样品特征</span>
						<el-input v-model="sampleEditData.sampleType"></el-input>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">样品数量</span>
						<el-input v-model="sampleEditData.num"></el-input>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">重量(mg)</span>
						<el-input v-model="sampleEditData.availableWeight"></el-input>
					</div>
				</div>
			</div>
			<div class="sampleBorrowingClass">
				<div class="titleDivClass">
					<span class="lineClass"></span>
					<span class="titleSpanNameClass">样品分类信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">一级分类</span>
						<el-input v-model="sampleEditData.sampleCategory1"></el-input>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">二级分类</span>
						<el-input v-model="sampleEditData.sampleCategory2"></el-input>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">三级分类</span>
						<el-input v-model="sampleEditData.sampleCategory3"></el-input>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">四级分类</span>
						<el-input v-model="sampleEditData.sampleCategory4"></el-input>
					</div>
				</div>

				<div class="titleDivClass">
					<span class="lineClass"></span>
					<span class="titleSpanNameClass">样品可用性信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">样品现有 重量(mg)</span>
						<el-input v-model="sampleEditData.currentWeight"></el-input>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">样品现有 重量(mg)</span>
						<el-input v-model="sampleEditData.availableWeight"></el-input>
					</div>
				</div>
				<div class="titleDivClass">
					<span class="lineClass"></span>
					<span class="titleSpanNameClass">图片样本信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="imgSampleClass">
					<span class="imgInforClass">
						<img src="./../../../assets/moonsamples/img1.png" />
						<span>CE6C0000YJYX181</span>
					</span>
					<span class="imgInforClass">
						<img src="./../../../assets/moonsamples/img2.png" style="margin-left: 10px" />
						<span>CE6C0000YJYX181</span>
					</span>
				</div>

				<div class="titleDivClass">
					<span class="lineClass"></span>
					<span class="titleSpanNameClass">样品分析报告</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">报告描述</span>
						<el-input v-model="sampleNum"></el-input>
					</div>
				</div>
				<div class="titleDivClass">
					<span class="lineClass"></span>
					<span class="titleSpanNameClass">样品分析数据</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">报告描述</span>
						<el-input v-model="sampleNum"></el-input>
					</div>
				</div>
				<div class="titleDivClass">
					<span class="lineClass"></span>
					<span class="titleSpanNameClass">样品其他信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">报告描述</span>
						<el-input v-model="sampleNum"></el-input>
					</div>
				</div>
			</div>
			<el-button @click="submitFunc()">确定</el-button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			sampleBorrwingTable: [],
			sampleNum: '',
			sampleEditData: ''
		}
	},
	methods: {
		goBack() {
			this.$emit('goBackFunc', 2)
		},
		initDataFunc(row) {
			console.log(row)
			this.sampleEditData = row
		},
		async submitFunc() {
			let res = await this.$http.post(this.$const.moonSample.editMoonSample, this.sampleEditData)
			if (res && res.code == 200) {
				this.$message.success('修改成功')
				this.goBack()
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.editMoonSampleInfoClass {
	width: 1200px;
	text-align: center;
	display: inline-block;
	.backClass {
		height: 40px;
		width: 100%;
		background: linear-gradient(90deg, rgba(251, 251, 251, 0.5) 0%, #f8f8f8 49%, rgba(245, 245, 245, 0.5) 100%);
		line-height: 40px;
	}
	.titleNameClass {
		height: 80px;
		font-family: MicrosoftYaHeiUISemibold;
		font-size: 28px;
		color: #000000;
		line-height: 80px;
		text-align: left;
		font-style: normal;
	}
	.contentDivClass {
		width: 1200px;
		// height: 1196px;
		background: #ffffff;
		border-radius: 4px;
		padding: 24px;
		border: 1px solid rgba(21, 65, 140, 0.2);
		.spanInforDivClass,
		.sampleBorrowingClass {
			display: flex;
			flex-direction: column;
			justify-content: left;
			.titleDivClass {
				display: flex;
				justify-content: left;
				align-items: center;
				height: 60px;
				.lineClass {
					width: 2px;
					height: 16px;
					margin-right: 4px;
					background: #15418c;
				}
				.titleSpanNameClass {
					// width: 108px;
					height: 19px;
					font-family: ReeJi-BigRuixain, ReeJi-BigRuixain;
					font-weight: normal;
					font-size: 18px;
					color: #15418c;
					line-height: 19px;
					text-align: left;
					font-style: normal;
					font-weight: 600;
				}
				.lineRightClass {
					width: 88%;
					border-style: dashed;
					border-width: 1px;
					border-color: #abc0e3;
				}
			}
			.spanInforClass {
				display: flex;
				align-items: center;
				justify-content: left;
				// width: 1100px;
				// height: 60px;
				flex-wrap: wrap;
				.dataInforDivClass {
					display: flex;
					justify-content: left;
					align-items: center;
					margin-bottom: 10px;
					.nameClass {
						width: 120px;
						height: 40px;
						display: flex;
						align-items: center;
						justify-content: center;
						background: rgba(21, 65, 140, 0.08);
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						text-overflow: ellipsis;
					}
					.valueClass {
						// height: 21px;
						width: 150px;
						font-family: MicrosoftYaHeiUISemibold;
						font-size: 16px;
						color: #15418c;
						line-height: 21px;
						text-align: left;
						font-style: normal;
						word-break: break-all;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: normal;
					}
				}
			}
			.imgSampleClass {
				display: flex;
				justify-content: left;
				align-items: center;
				.imgInforClass {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: left;
					img {
						width: 166px;
						height: 114px;
					}
					span {
						width: 114px;
						height: 19px;
						font-family: MicrosoftYaHeiUI;
						font-size: 14px;
						color: #333333;
						line-height: 19px;
						text-align: left;
						font-style: normal;
					}
				}
			}
		}
	}
}
</style>

<style>
.dataInforDivClass .el-input__inner {
	width: 280px;
	height: 36px;
	/* background: #fafafa; */
	border-radius: 4px;
	border: 1px solid #cccccc;
}
</style>